export default __webpack_public_path__ + "static/media/videoHome.3459fa07.mp4";